import { Link } from "react-router-dom";
import ProductCard from "./ProductCard";

export const ProductGrid = ({ items, testid = "product-grid" }) => (
  <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4" data-testid={testid}>
    {items.map((p) => <ProductCard key={p.id} p={p} />)}
  </div>
);

export const SectionTitle = ({ eyebrow, title, link, linkLabel = "Ver todos" }) => (
  <div className="mb-10 flex flex-wrap items-end justify-between gap-4">
    <div>
      <p className="eyebrow mb-3">{eyebrow}</p>
      <h2 className="font-serif text-3xl font-medium text-[#FAF6F0] sm:text-4xl lg:text-5xl">{title}</h2>
    </div>
    {link && <Link to={link} className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] underline-offset-4 hover:underline" data-testid={`section-link-${eyebrow.toLowerCase().replace(/\s+/g, "-")}`}>{linkLabel} →</Link>}
  </div>
);
